import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { GlobalContext } from "../../context/GlobalState";

const PlanCards = ({
  name,
  id,
  mostPopular,
  price,
  features,
  currentPlan,
  history,
}) => {
  const { currentWorkspace } = useContext(GlobalContext);
  const isDowngrade = currentPlan && currentPlan.price > price;
  const isUpgrade = currentPlan && currentPlan.price < price;
  const isCurrent = currentPlan && currentPlan.price === price;
  const isFree = price === 0;
  const buttonType =
    isFree && isDowngrade
      ? "cancel"
      : isDowngrade
      ? "downgrade"
      : isUpgrade
      ? "upgrade"
      : isCurrent
      ? "selected"
      : "upgrade";

  const handleClick = () => {
    if (currentPlan.id === id) {
      return;
    }
    history.push(`/checkout/${id}`);
  };

  return (
    <div className={container + (mostPopular ? " most-popular" : "")}>
      <p className="most-popular">{mostPopular && "MOST POPULAR"}</p>
      <div className="top-row">
        <h4>{name.toUpperCase()}</h4>
        <span
          onClick={handleClick}
          className={"select-plan-button " + buttonType}
        >
          {buttonType[0].toUpperCase() + buttonType.slice(1)}
        </span>
      </div>
      <div className="features">
        <ul>
          {features.map((feature, i) => (
            <li key={`feature-${i}`}>{feature}</li>
          ))}
        </ul>
      </div>
      <p className="price">{<span>{price}</span>}/ mo</p>
    </div>
  );
};

export default withRouter(PlanCards);

const container = css`
  margin-bottom: 30px;
  padding: 15px;
  box-shadow: ${boxStyles.boxShadow};
  border-radius: ${boxStyles.borderRadius};
  position: relative;
  min-width: 290px;
  transition-duration: 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  &.most-popular {
    border-top: 10px solid ${colors.accentColor};
  }

  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    h4 {
      font-size: 24px;
      letter-spacing: 1px;
    }
  }

  .most-popular {
    color: ${colors.accentColor};
    font-size: 11px;
    letter-spacing: 1px;
    font-weight: 500;
  }

  .select-plan-button {
    background-color: white;
    box-shadow: ${boxStyles.boxShadow};
    padding: 5px 12px;
    border-radius: 30px;
    cursor: pointer;
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: 500;
    transition-duration: 0.2s;

    &.selected {
      color: white;
      background-color: ${colors.brandColor};
    }

    &.upgrade {
      color: ${colors.brandColor};

      &:hover {
        background-color: ${colors.brandColor};
        color: white;
      }
    }

    &.downgrade,
    &.cancel {
      color: ${colors.placeholderText};
    }
  }

  .features {
    ul {
      padding-left: 30px;
      list-style: none;
      font-size: 14px;
      color: ${colors.subtitleColor};

      li {
        position: relative;
        margin-top: 8px;

        &::before {
          content: "✓";
          display: block;
          position: absolute;
          background-color: ${colors.brandColor};
          color: white;
          height: 18px;
          width: 18px;
          border-radius: 50%;
          left: -30px;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
          line-height: 18px;
          text-align: center;
        }
      }
    }
  }

  .price {
    position: absolute;
    bottom: 5px;
    right: 15px;
    font-size: 14px;
    font-weight: bold;

    span {
      font-size: 36px;
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .select-plan-button {
      font-size: 14px;
      padding: 5px 14px;
    }
  }
`;
